import { render } from "./user_panel.vue?vue&type=template&id=460aaa4a"
import script from "./user_panel.js?vue&type=script&lang=js"
export * from "./user_panel.js?vue&type=script&lang=js"

import "./user_panel.vue?vue&type=style&index=0&id=460aaa4a&lang=scss"

import exportComponent from "/woodpecker/src/akkoma.dev/AkkomaGang/akkoma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__